import React from 'react'
import { useTranslation } from 'react-i18next'

import { BudgetChartBudgets } from 'src/types'

import BudgetChart from 'src/components/molecules/budget-chart'

import { StyledNotFound } from './styles'

interface Props {
  bars: BudgetChartBudgets[]
}

/**
 *
 * @param bars BudgetChartBudgets[]
 * @returns Returns structure of chart bars
 */
function Budget({ bars }: Props) {
  const { t } = useTranslation()

  if (!bars.length) {
    return <StyledNotFound>{t('common.no-data')}</StyledNotFound>
  }

  return (
    <>
      {bars.map(barChart => (
        <BudgetChart bars={barChart} key={barChart.key} />
      ))}
    </>
  )
}

export default Budget
